import { DS_BUTTON_SIZE, type DSButtonSize } from "@/src/design_system/button_and_controls/button/types/props";
import {
  DS_ACCORDION_SIZE,
  type DSAccordionSize,
} from "@/src/design_system/layouts_and_containers/accordion/types/size";

export const DS_ACCORDION_CLASSES = {
  Root: "ds-accordion",
  Header: "ds-accordion__header",
  HeaderInteractive: "ds-accordion__header--interactive",
  Label: "ds-accordion__label",
  Subtitle: "ds-accordion__subtitle",
  Suffix: "ds-accordion__suffix",
  Toggle: "ds-accordion__toggle",
  Divider: "ds-accordion__divider",
  Content: "ds-accordion__content",
} as const;

export const DS_ACCORDION_HEADER_INTERACTIVE_SELECTOR = "a, button, input, select, textarea, label, [role='button']";

export const DS_ACCORDION_SIZE_TO_CLASS_MAP: Record<DSAccordionSize, string> = {
  [DS_ACCORDION_SIZE.Small]: `${DS_ACCORDION_CLASSES.Root}--sm`,
  [DS_ACCORDION_SIZE.Medium]: `${DS_ACCORDION_CLASSES.Root}--md`,
  [DS_ACCORDION_SIZE.Large]: `${DS_ACCORDION_CLASSES.Root}--lg`,
};

export const DS_ACCORDION_SIZE_TO_BUTTON_SIZE_MAP: Record<DSAccordionSize, DSButtonSize> = {
  [DS_ACCORDION_SIZE.Small]: DS_BUTTON_SIZE.ExtraSmall,
  [DS_ACCORDION_SIZE.Medium]: DS_BUTTON_SIZE.ExtraSmall,
  [DS_ACCORDION_SIZE.Large]: DS_BUTTON_SIZE.Small,
};
